// extracted by mini-css-extract-plugin
export var breadcrumbs = "lcArticleLayout-module--breadcrumbs--2086c";
export var contactBlock = "lcArticleLayout-module--contactBlock--76dc7";
export var container = "lcArticleLayout-module--container--1297b";
export var containerInner = "lcArticleLayout-module--containerInner--62ac2";
export var landingPage = "lcArticleLayout-module--landingPage--6477e";
export var title = "lcArticleLayout-module--title--f80a8";